import type { DecodedPackCreativesGroup } from 'hooks/useLocationParams';

interface TikTokPack {
  tag: string;
  creatives: string[];
  filterCreativeByName: string[];
}

const EMPTY_PACK: TikTokPack = {
  tag: '',
  creatives: [],
  filterCreativeByName: [],
};

/** Rebuilds packs (in index order) from URL-restored pack groups, restoring each pack's tag. */
export const buildPacksFromCreativesByPack = (
  creativesByPack: readonly DecodedPackCreativesGroup[],
): TikTokPack[] => {
  if (!creativesByPack.length) return [];

  const packCount = Math.max(...creativesByPack.map((group) => group.index)) + 1;
  const groupByIndex = new Map(creativesByPack.map((group) => [group.index, group]));

  return Array.from({ length: packCount }, (_, index) => {
    const group = groupByIndex.get(index);
    return {
      tag: group?.tag ?? '',
      creatives: group?.creatives ?? [],
      filterCreativeByName: [],
    };
  });
};

export const getDefaultTikTokPack = (): TikTokPack => ({ ...EMPTY_PACK, creatives: [] });
